'use strict'

module.exports = orientation

function orientation(s) {
  var p = 1
  for(var i=1; i<s.length; ++i) {
    for(var j=0; j<i; ++j) {
      if(s[i] < s[j]) {
        p = -p
      } else if(s[j] === s[i]) {
        return 0
      }
    }
  }
  return p
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/cell-orientation/orientation.js
// module id = LbB/
// module chunks = 0